import axios from 'axios';
import {
  SETTING_ACCOUNT,
  VERIFY_UPDATE_OTP_URL,
  VERIFY_OTP_URL,
  UPLOAD_NPWP_FILE_URL,
} from './constants';

export function apiSettingAccount(data) {
  return axios
    .put(SETTING_ACCOUNT, data, { withCredentials: true })
    .catch(error => {
      return Promise.reject(new Error(error.response.data.errors));
    });
}

export function apiVerifyUpdateOtp(data) {
  return axios
    .post(`${VERIFY_UPDATE_OTP_URL}?verify_phone_number=true`, data, {
      withCredentials: true,
    })
    .catch(error => {
      return Promise.resolve(error.response);
    });
}

export function apiVerifyOtp(data) {
  return axios
    .post(VERIFY_OTP_URL, data, { withCredentials: true })
    .catch(error => {
      return Promise.reject(new Error(error.response.data.reason));
    });
}

export function uploadNpwpFile(data) {
  const config = {
    withCredentials: true,
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return axios.post(UPLOAD_NPWP_FILE_URL, data, config);
}
